export { getCustomBlock } from './registry'
